
<template>
  <!--  新增考题-->
  <div class="dialog" >
    <el-form ref="form" :model="form" label-width="130px" >
      <el-form-item label="难易程度" style="width: 100%">
        <el-radio-group v-model="form.difficulty_level">
          <el-radio :label="3001">简单</el-radio>
          <el-radio :label="3002">一般</el-radio>
          <el-radio :label="3003">较难</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="题目状态" style="width: 100%">
        <el-radio-group v-model="form.status">
          <el-radio :label="4001">有效</el-radio>
          <el-radio :label="4002">失效</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="题型设置" style="width: 100%">
        <el-radio-group v-model="form.question_type" @change="handleQuestionTypeChange">
          <el-radio :label="2001">单选题</el-radio>
          <el-radio :label="2002">多选题</el-radio>
          <el-radio :label="2003">是非题</el-radio>
          <el-radio :label="2004">填空题</el-radio>
          <el-radio :label="2005">问答题</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="题干内容" style="width: 100%">
        <el-input type="textarea" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="选项内容" style="width: 100%" v-if="[2001,2002,2003].includes(form.question_type)">
       <div>
         <div v-for="(item, index) in form.options" :key="item.sort_order">
           <span  v-if="[2001,2002].includes(form.question_type)" class="opt-item">{{item.value}}</span>
           <span class="opt-item">
              <el-input  v-model="item.option_text" ></el-input>
           </span>
           <span class="opt-item">
             <span v-if="[2001,2003].includes(form.question_type)" class="opt-item">

              <el-radio v-model="form.correctOptionIndex" class="correct" :label="index"></el-radio>正确答案
             </span>
             <span v-if="[2002].includes(form.question_type)" class="opt-item">
               <el-checkbox v-model="item.is_correct" style="margin-right: 8px;"></el-checkbox>正确答案
             </span>

           </span>
           <span v-if="form.options.length > 1 " class="opt-item">
             <el-button @click="handleRemoveOptionItem(index)" style="border-color: #E34D59;color: #E34D59 ;">删除</el-button>
           </span>
         </div>
       </div>
        <el-button  v-if="[2001,2002,2003].includes(form.question_type)" @click="handleAddOpt" style="color:#4787F0;border-color:#4787F0">新增</el-button>
      </el-form-item>
      <el-form-item label="参考答案" style="width: 100%" v-if="[2004,2005].includes(form.question_type)">
        <el-input type="textarea" v-model="form.options"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <!--  </el-dialog>-->
</template>
<script>
import {getQuestDtl, saveQuestions, updateQuestions} from "@/api/training";
export default {
  name: "addQuestionDialog",
  props: {
    questionId: {
      type: Number,
      default: 0
    },
    currentQuestion: {
      type: Object,
      default: () => {}
    },
    isNew: {
      type: Boolean,
      default: false
    },
    questIndex: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      value: [],
      form: {
        repository: Number(this.$route.query.id),
        difficulty_level: 3001,
        status: 4001,
        question_type: 1,
        options:[],
        questIndex: null,
        correctOptionIndex: null,
        title: '',
      }
    };
  },
  watch: {
    'form.correctOptionIndex'(newIndex) {
      // 先清空所有选项的 is_correct
      this.form.options.forEach((item, i) => {
        item.is_correct = (i === newIndex);
      });
    }
  },
  created() {
    this.form.options = []
    if(this.questionId !==0 && !!this.questionId){
      this.getQuestDtl()
    }else{
      if(!this.isNew){
        // this.form = this.currentQuestion
        this.form.repository = this.currentQuestion.repository;
        this.form.difficulty_level = this.currentQuestion.difficulty_level;
        this.form.status = this.currentQuestion.status;
        this.form.question_type = this.currentQuestion.question_type;
        this.form.questIndex = this.currentQuestion.questIndex;
        this.form.option_text = this.currentQuestion.option_text;
        this.form.title = this.currentQuestion.title;
        if([2004,2005].includes(this.form.question_type)){ //form.options
          this.form.options =  this.currentQuestion.option_text || this.currentQuestion.options
        }else{
          if( this.form.option_text){
            this.form.option_text.forEach((item,index)=>{
              item.value =String.fromCharCode(64 + index +1)
              item.id = item.answer_id
              item.option_text= item.option_text
              item.is_correct=item.is_correct
            })
            this.form.options = this.form.option_text
          }else{
            this.form.options = this.currentQuestion.options
          }
          if([2001,2003].includes(this.form.question_type)){
            this.form.options.forEach((item, i) => {
              if(item.is_correct){
                this.form.correctOptionIndex = i
              }
            });
          }
        }
      }else{
        this.form = {
          difficulty_level: 3001,
          status: 4001,
          options:[]
        }

      }

    }
  },

  methods: {
    getQuestDtl(){ //获取题目详情
      getQuestDtl({id:this.questionId}).then(res=>{
        let resData = res.data
        this.form.repository = resData.repository;
        this.form.difficulty_level = resData.difficulty_level;
        this.form.status = resData.status;
        this.form.question_type = resData.question_type;
        this.form.questIndex = resData.questIndex;
        this.form.option_text = resData.option_text;
        this.form.title = resData.title;
        if([2004,2005].includes(this.form.question_type)){ //form.options
          this.form.options = this.form.option_text
        }else{
          this.form.option_text.forEach((item,index)=>{
            item.value =String.fromCharCode(64 + index +1)
            item.id = item.answer_id
            item.option_text= item.option_text
            item.is_correct=item.is_correct
          })
          this.form.options = this.form.option_text
          if([2001,2003].includes(this.form.question_type)){
            this.form.options.forEach((item, i) => {
              if(item.is_correct){
                this.form.correctOptionIndex = i
              }
            });
          }
        }
      })
    },
    handleAddOpt(){ //新增选项
      let index = this.form.options.length ? this.form.options.length : 0
      this.form.options.push({
        value: String.fromCharCode(64 + index +1),
        option_text: '',
        is_correct: false,
        sort_order: index,
      })
    },
    handleRemoveOptionItem(index){
      this.form.options.splice(index,1)
      this.form.options.forEach((item,index)=>{
        item.value = String.fromCharCode(64 + index +1),
        item.sort_order = index
      })
    },
    saveFormData(){
      if(!this.form.question_type){
        this.$message.error('请选择题型')
        return
      }
      if(!this.form.title){
        this.$message.error('请填写题干内容')
        return
      }
      if([2001,2002,2003].includes(this.form.question_type) ){
        if(this.form.options.length >0){
          if(!this.form.options.some(item => item.is_correct)){
            this.$message.error('请选择正确答案')
            return
          }
        }else{
          this.$message.error('请填写选项内容')
          return
        }
        // 如果options里所有选择没有is_correct 为true的选项，则提示请选择正确答案

      }else{
        if(this.form.options == ''){
          this.$message.error('请填写正确答案')
          return
        }
      }
      this.loading = true
      if(this.questionId!== 0){ // 修改
        updateQuestions({id:this.questionId,data:this.form}).then(res=>{
          if(res.code==200){
            this.$message.success('保存成功')
            this.$emit('update')
            this.resetForm()
          }else{
            this.$message.error(res.msg)
          }
        }).finally(() => {
          this.loading = false

        })

      }else{
        if(this.$route.query.id){ // 新增
          this.form.repository = Number(this.$route.query.id)
          saveQuestions(this.form).then(res=>{
            if(res.code==200){
              this.$message.success('保存成功')
              this.$emit('update')

            }else{
              this.$message.error(res.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }else{
          this.form.questIndex = this.questIndex
          this.$emit('saveFormData',this.form)
          this.loading = false
        }
      }
    },
    resetForm(){
      this.form = {
        difficulty_level: 3001,
        status: 4001,
        question_type: 1,
        options:[],
        questIndex: null
      }
    },
    handleQuestionTypeChange(){
      this.form.options = []
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form-item{
  display: inline-block;
}

::v-deep .el-input .el-input__inner{
  width: 100%;
}
::v-deep .el-radio-group{
  display: inline-block;
  width: 100%;
}
::v-deep .el-radio{
  display: inline-block!important;

}
.opt-item{
  display: inline-block;
  margin: 0 16px 16px 0;
}
::v-deep .correct .el-radio__label{ //correct
  display: none;
  margin-right: 8px;
}
</style>